export default function CommunitySection() {
  return null;
}